import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "jp-sync"
};
const _hoisted_2 = {
  class: "jp-sync__body"
};
const _hoisted_3 = {
  key: 0,
  class: "jp-sync__debts"
};
const _hoisted_4 = {
  key: 0,
  class: "jp-sync__wait"
};
const _hoisted_5 = {
  key: 2,
  class: "jp-sync__wait"
};
const _hoisted_6 = {
  class: "jp-sync__panel"
};
const _hoisted_7 = {
  class: "jp-sync__treasury"
};
const _hoisted_8 = {
  class: "jp-sync__actions"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
  key: 0,
  class: "jp-sync__err"
};
const _hoisted_11 = {
  key: 1,
  class: "jp-sync__hash"
};
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { confirmJackpotSync, getJackpotSyncStatus } from '@/api/jackpot';
import { getAccessToken } from '@/utils/auth-token';
import { sendRcTokenTransfer, isUserRejectedError } from '@/utils/rc-deposit-transfer';
import { getDusdContractAddress } from '@/utils/trade-contracts';
export default {
  __name: 'JackpotSyncBanner',
  setup(__props, {
    expose: __expose
  }) {
    const pending = ref(false);
    const silentAlign = ref(true);
    const totalBurn = ref('0');
    const totalMint = ref('0');
    const treasury = ref('');
    const debts = ref([]);
    const open = ref(false);
    const txHash = ref('');
    const submitting = ref(false);
    const err = ref('');
    let timer = null;
    const hasBurn = computed(() => Number(totalBurn.value) > 0);
    async function refresh() {
      const {
        refreshJackpotFeature
      } = await import('@/composables/useJackpotFeature.js');
      const on = await refreshJackpotFeature();
      if (!on) {
        pending.value = false;
        return;
      }
      if (!getAccessToken()) {
        pending.value = false;
        return;
      }
      try {
        const data = await getJackpotSyncStatus();
        pending.value = !!data?.pending;
        // Hide MetaMask only for pure silent; manual/mixed keep confirm entry.
        const mode = data?.alignMode || (data?.silentAlign === false ? 'manual' : 'silent');
        silentAlign.value = mode === 'silent';
        totalBurn.value = data?.totalBurn || '0';
        totalMint.value = data?.totalMint || '0';
        treasury.value = data?.treasury || '';
        debts.value = data?.debts || [];
        if (silentAlign.value && open.value) open.value = false;
      } catch {
        pending.value = false;
      }
    }
    async function onMetaMaskTransfer() {
      err.value = '';
      submitting.value = true;
      txHash.value = '';
      try {
        const to = String(treasury.value || '').trim();
        const token = getDusdContractAddress();
        if (!to) throw new Error('treasury missing');
        if (!token) throw new Error('VUE_APP_DUSD_CONTRACT not configured');
        const amount = String(totalBurn.value || '0');
        if (Number(amount) <= 0) throw new Error('nothing to burn');
        const {
          txHash: hash
        } = await sendRcTokenTransfer({
          toAddress: to,
          contractAddress: token,
          amount,
          decimals: 18,
          chainId: Number(process.env.VUE_APP_CHAIN_ID) || 137,
          waitForConfirmation: true
        });
        txHash.value = hash;
        const ids = debts.value.filter(d => d.debtType === 'BURN').map(d => d.id);
        await confirmJackpotSync({
          debtIds: ids,
          txHash: hash
        });
        open.value = false;
        await refresh();
      } catch (e) {
        if (isUserRejectedError?.(e)) {
          err.value = '已取消签名';
        } else {
          err.value = e?.message || String(e);
        }
      } finally {
        submitting.value = false;
      }
    }
    onMounted(() => {
      refresh();
      // Silent path: poll faster so gate clears without user action.
      timer = setInterval(refresh, 5000);
    });
    onUnmounted(() => {
      if (timer) clearInterval(timer);
    });
    __expose({
      refresh
    });
    return (_ctx, _cache) => {
      return pending.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.$t('jackpot.syncTitle')), 1), _createElementVNode("p", null, [_createTextVNode(_toDisplayString(silentAlign.value ? _ctx.$t('jackpot.syncSilentDesc') : _ctx.$t('jackpot.syncDesc')) + " ", 1), hasBurn.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(" · " + _toDisplayString(totalBurn.value) + " pUSD", 1)], 64)) : _createCommentVNode("", true)]), debts.value.length ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(debts.value, d => {
        return _openBlock(), _createElementBlock("li", {
          key: d.id
        }, " #" + _toDisplayString(d.roundId) + " " + _toDisplayString(d.debtType) + " " + _toDisplayString(d.amount) + " (" + _toDisplayString(d.status) + ") ", 1);
      }), 128))])) : _createCommentVNode("", true)]), silentAlign.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('jackpot.syncSilentWait')), 1)) : hasBurn.value ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: "jp-sync__btn",
        onClick: _cache[0] || (_cache[0] = $event => open.value = true)
      }, _toDisplayString(_ctx.$t('jackpot.syncAction')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('jackpot.syncMintWait')), 1))]), open.value && !silentAlign.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "jp-sync__modal",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => open.value = false, ["self"]))
      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('jackpot.syncTitle')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('jackpot.syncEoAHint')), 1), _createElementVNode("p", _hoisted_7, "Treasury: " + _toDisplayString(treasury.value || '—'), 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(debts.value, d => {
        return _openBlock(), _createElementBlock("li", {
          key: d.id
        }, " #" + _toDisplayString(d.roundId) + " " + _toDisplayString(d.debtType) + " " + _toDisplayString(d.amount) + " (" + _toDisplayString(d.status) + ") ", 1);
      }), 128))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = $event => open.value = false)
      }, _toDisplayString(_ctx.$t('jackpot.cancel')), 1), _createElementVNode("button", {
        type: "button",
        class: "jp-sync__btn",
        disabled: submitting.value,
        onClick: onMetaMaskTransfer
      }, _toDisplayString(submitting.value ? _ctx.$t('jackpot.buying') : _ctx.$t('jackpot.syncMetamask')), 9, _hoisted_9)]), err.value ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(err.value), 1)) : _createCommentVNode("", true), txHash.value ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(txHash.value), 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};